/**
 * Origin used for Thawani success/cancel URLs.
 * Prefer REACT_APP_SITE_URL in dev when PORT=3001 is set for the email server but the SPA runs on :3000.
 */
export function getPaymentReturnOrigin() {
  const fromEnv = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_PUBLIC_URL || '')
    .trim()
    .replace(/\/+$/, '');
  if (fromEnv && /^https?:\/\//i.test(fromEnv)) {
    return fromEnv;
  }
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (/^https?:\/\/(localhost|127\.0\.0\.1):3001$/i.test(origin)) {
    return origin.replace(':3001', ':3000');
  }
  return origin;
}
